import ConditionalInput from '../../ConditionalInput';

import { Box, Button, Checkbox, Flex, rem, Text, Tooltip } from '@mantine/core';
import { BiPlus, BiTrash } from 'react-icons/bi';
import { LuEqual } from 'react-icons/lu';
import { FaRegCircleQuestion } from 'react-icons/fa6';

export const ConditionCombination = ({
  column,
  columns,
  operator,
  fuzzyMatching,
  onChangeColumn,
  onChangeOperator,
  onAddCondition,
  onDeleteCondition,
  secondColumns,
  disableDelete,
  onChangeFuzzyMatching
}) => {
  return (
    <div id="grid-table-join-condition" className="condition">
      <div id="grid-table-join-condition-first" className="table">
        <Text id="grid-table-join-condition-first-label" size={rem(14)} fw={600}>
          First Table <span className="required">*</span>
        </Text>

        <ConditionalInput
          type="column"
          value={column}
          columns={columns}
          required={true}
          onChangeValue={onChangeColumn}
          hiddenVariants={['input', 'column', 'null', 'ai_input']}
        />
      </div>

      {/* <span className="operator">=</span> */}
      <LuEqual color="#ADB5BD" style={{ marginBottom: 8, minWidth: 30 }} />

      <div id="grid-table-join-condition-second" className="table">
        <Text id="grid-table-join-condition-second-label" size={rem(14)} fw={600}>
          Second Table <span className="required">*</span>
        </Text>
        <ConditionalInput
          type="column"
          required={true}
          value={operator}
          columns={secondColumns}
          onChangeValue={onChangeOperator}
          hiddenVariants={['input', 'column', 'null', 'ai_input']}
        />
      </div>

      <Box id="grid-table-join-condition-fuzzy" ml={rem(16)}>
        <div id="grid-table-join-condition-fuzzy-box" className="table">
          <Text id="grid-table-join-condition-fuzzy-label" size={rem(14)} fw={600} ta="center">
            Fuzzy Matching{' '}
            <Tooltip
              label={
                <>
                  Use Fuzzy Join to link records that are close but not exact,
                  <br /> such as those with typos or slight variations.
                </>
              }
            >
              <button id="grid-table-join-condition-fuzzy-help">
                <FaRegCircleQuestion color="#228BE6" />
              </button>
            </Tooltip>
          </Text>

          <Flex id="grid-table-join-condition-fuzzy-toggle" justify="center" align="center" h={34}>
            <Checkbox
              id="grid-table-join-condition-fuzzy-checkbox"
              checked={fuzzyMatching}
              onChange={() => onChangeFuzzyMatching(!fuzzyMatching)}
            />
          </Flex>
        </div>
      </Box>

      <Button
        id="grid-table-join-condition-add"
        w={rem(48)}
        h={rem(30)}
        ml={rem(16)}
        variant="outline"
        onClick={onAddCondition}
        p={0}
      >
        <BiPlus size={20} fontSize={20} />
      </Button>

      {!disableDelete && (
        <Button
          id="grid-table-join-condition-delete"
          w={rem(48)}
          h={rem(30)}
          ml={rem(16)}
          variant="outline"
          color="red"
          p={0}
          onClick={onDeleteCondition}
        >
          <BiTrash />
        </Button>
      )}
    </div>
  );
};
